$(document).on('turbolinks:load', function () {
  if ($('body').hasClass('whatsapp_agents')) {
    $('.whatsapp_ignore_ia_add').on('click', '', function (e) {
      $('.modal-photo').show()
      let whatsapp_number = $("#addNewNumber").val().replace(/[^0-9]/g, '')
      $.post("/whatsapp_ignore_ia_add?whatsapp_number=" + whatsapp_number + "&whatsapp_instance_id=" + $("#whatsapp_instance_id").val(), function (data, status) {
        if (data.status) {
          $("#addNewNumber").val('')
          $("#send_whatsapp_numbers").prepend("<div class='send_whatsapp_number_div' id=" + data.id + "><a href='javascript:void(0)' style='color: red' onclick='window.whatsappAgentIaDel(this)'><i class='fa fa-trash' aria-hidden='true' style='font-size: 25px;'></i></a><span> " + whatsapp_number + '</span></div>');
        }
        $('.modal-photo').hide()
      });
    });
    window.whatsappAgentIaDel = function (div) {
      console.log(div)
      div = $(div).parent()[0]
      console.log(div)
      if (window.confirm("Confirm?")) {
        $('.modal-photo').show()
        $.post("/whatsapp_ignore_ia_del?whatsapp_number=" + $(div).attr('id') + "&whatsapp_instance_id=" + $("#whatsapp_instance_id").val(), function (data, status) {
          if (data.status) {
            div.remove();
          }
          $('.modal-photo').hide()
        });
      }
    }
    const promptTextarea = document.getElementById('whatsapp_agent_prompt');
    const charCountSpan = document.getElementById('prompt-char-count');
    const limitWrapper = document.getElementById('prompt-max-limit-wrapper');
    const limitSpan = document.getElementById('prompt-max-limit');

    function updatePromptCount() {
      if (!promptTextarea || !charCountSpan) return;
      const isSendfy = $("#whatsapp_agent_model_llm").val() === "sendfy";
      const limit = parseInt(promptTextarea.getAttribute('data-limit') || promptTextarea.getAttribute('data-max-chars') || 10000);
      const currentLength = promptTextarea.value.length;

      charCountSpan.textContent = currentLength;

      if (isSendfy) {
        if (limitWrapper) $(limitWrapper).show();
        if (limitSpan) limitSpan.textContent = limit;
        promptTextarea.setAttribute('maxlength', limit);

        if (currentLength > limit) {
          charCountSpan.classList.add('text-danger');
        } else {
          charCountSpan.classList.remove('text-danger');
        }
      } else {
        if (limitWrapper) $(limitWrapper).hide();
        promptTextarea.removeAttribute('maxlength');
        charCountSpan.classList.remove('text-danger');
      }
    }

    function check_llm() {      
      const currentModelLlm = $("#whatsapp_agent_model_llm").val();
      const limit = parseInt(promptTextarea ? (promptTextarea.getAttribute('data-limit') || promptTextarea.getAttribute('data-max-chars') || 10000) : 10000);

      $(".llm-select").show();
      $("#whatsapp_agent_llm").show();
      $("#whatsapp_agent_gpt_key").show();

      if (currentModelLlm == "gemini") {
        $(".get_gemini_llms").show();
        $(".get_openai_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").attr('href', 'https://aistudio.google.com/app/apikey');
      } else if (currentModelLlm == "openai") {
        $(".get_openai_llms").show();
        $(".get_gemini_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").attr('href', 'https://platform.openai.com/api-keys');
      } else if (currentModelLlm == "openrouter") {
        $(".get_openrouter_llms").show();
        $(".get_gemini_llms").hide();
        $(".get_openai_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").attr('href', 'https://openrouter.ai/settings/keys');
      } else if (currentModelLlm == "groq") {
        $(".get_groq_llms").show();
        $(".get_openai_llms").hide();
        $(".get_gemini_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".api_gpt_key").attr('href', 'https://console.groq.com/keys');
      } else if (currentModelLlm == "sendfy") {
        $(".llm-select").hide();
        $(".get_openai_llms").hide();
        $(".get_gemini_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").hide();
        $("#whatsapp_agent_llm").hide();
        $("#whatsapp_agent_gpt_key").hide();

        if (promptTextarea && promptTextarea.value.length > limit) {
          alert('Atenção: O prompt atual possui ' + promptTextarea.value.length + ' caracteres. Para utilizar a IA da Sendfy, o limite máximo é de ' + limit + ' caracteres. Por favor, reduza o prompt para poder salvar.');
        }
      }

      updatePromptCount();
    }

    $("#whatsapp_agent_model_llm").on('change', function (e) {
      check_llm();
    });

    if (promptTextarea) {
      $(promptTextarea).on('input keyup paste', function() {
        updatePromptCount();
      });
    }

    $(document).on('submit', 'form', function (e) {
      const isSendfy = $("#whatsapp_agent_model_llm").val() === "sendfy";
      if (isSendfy && promptTextarea) {
        const limit = parseInt(promptTextarea.getAttribute('data-limit') || promptTextarea.getAttribute('data-max-chars') || 10000);
        const currentLength = promptTextarea.value.length;
        if (currentLength > limit) {
          e.preventDefault();
          alert('Atenção! Não é possível salvar com a IA da Sendfy: O prompt possui ' + currentLength + ' caracteres, mas o limite permitido é de ' + limit + ' caracteres. Por favor, reduza o prompt.');
          promptTextarea.focus();
          return false;
        }
      }
    });

    check_llm();

    // Clear agent memory
    $(document).on('click', '#btn-clear-agent-memory', function () {
      var btn = $(this);
      if (confirm('Tem certeza que deseja limpar a memória do agente?')) {
        var agentId = btn.data('agent-id');
        var statusSpan = $('#clear-memory-status');
        
        btn.prop('disabled', true);
        statusSpan.show();
        
        $.ajax({
          url: '/whatsapp_agents/' + agentId + '/clear_memory',
          type: 'POST',
          dataType: 'json',
          success: function(response) {
            alert('Memória do agente limpa com sucesso!');
          },
          error: function(xhr, status, error) {
            var msg = 'Erro ao limpar a memória do agente.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              msg += ' ' + xhr.responseJSON.message;
            }
            alert(msg);
          },
          complete: function() {
            btn.prop('disabled', false);
            statusSpan.hide();
          }
        });
      }
    });
  }
})

